import { Choice } from '../models/choice';

export const hazmatClasses: Choice[] = [

];
